var exports = {
  "s": "x234b8571--7dcc70--component",
  "P": "x234b8571--7dcc70--label",
};

module.exports = exports;
